"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BeakerIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation-delay: 0.6s;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation-delay: 0.3s;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", " 1.5s ease-in infinite;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Bubbling = (0, _styledComponents.keyframes)(_templateObject());
var bubblingAnimationMixin = (0, _styledComponents.css)(_templateObject2(), Bubbling);

var Bubble1 = _styledComponents.default.ellipse.withConfig({
  displayName: "BeakerIcon__Bubble1",
  componentId: "sc-7nghc2-0"
})(_templateObject3(), bubblingAnimationMixin);

var AnimatedBubble = _styledComponents.default.g.withConfig({
  displayName: "BeakerIcon__AnimatedBubble",
  componentId: "sc-7nghc2-1"
})(_templateObject4(), bubblingAnimationMixin);

var Bubble2 = (0, _styledComponents.default)(AnimatedBubble).withConfig({
  displayName: "BeakerIcon__Bubble2",
  componentId: "sc-7nghc2-2"
})(_templateObject5());
var Bubble3 = (0, _styledComponents.default)(AnimatedBubble).withConfig({
  displayName: "BeakerIcon__Bubble3",
  componentId: "sc-7nghc2-3"
})(_templateObject6());

function BeakerIcon(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: className
  }), _react.default.createElement("svg", {
    viewBox: "0 0 86 213",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement(Bubble1, {
    fill: "#BEE7EE",
    cx: "48.091",
    cy: "74.657",
    rx: "3.818",
    ry: "3.851"
  }), _react.default.createElement(Bubble2, {
    transform: "translate(26.455 40)"
  }, _react.default.createElement("ellipse", {
    fill: "#BEE7EE",
    cx: "10.182",
    cy: "10.269",
    rx: "10.182",
    ry: "10.269"
  }), _react.default.createElement("ellipse", {
    fill: "#FFF",
    cx: "8.145",
    cy: "6.161",
    rx: "4.073",
    ry: "2.054"
  })), _react.default.createElement(Bubble3, {
    transform: "translate(39)"
  }, _react.default.createElement("circle", {
    fill: "#BEE7EE",
    cx: "15.5",
    cy: "15.5",
    r: "15.5"
  }), _react.default.createElement("ellipse", {
    fill: "#FFF",
    cx: "13.286",
    cy: "6.643",
    rx: "4.429",
    ry: "2.214"
  })), _react.default.createElement("path", {
    d: "M81.191 180.572l-27.023-56.3V107.17l3.616-10.38H28.572l3.618 10.38v17.103l-27.025 56.3c-4.238 7.878-.96 16.833 9.831 23.04 15.5 8.913 40.865 8.913 56.364 0 10.794-6.207 14.07-15.162 9.831-23.04z",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M32.63 101.15c-2.148-1.236-3.5-2.76-4.058-4.36-.95-2.727.402-5.67 4.058-7.77 5.8-3.337 15.295-3.337 21.096 0 3.657 2.1 5.008 5.043 4.058 7.77-.559 1.6-1.91 3.124-4.058 4.36-5.8 3.334-15.296 3.334-21.096 0z",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M35.399 111.006c-1.583-.909-2.58-2.035-2.992-3.217a3.777 3.777 0 0 1-.217-1.256c0-1.62 1.07-3.242 3.209-4.473 4.28-2.46 11.28-2.46 15.559 0 2.139 1.231 3.21 2.853 3.21 4.473 0 .421-.073.843-.218 1.256-.411 1.182-1.41 2.308-2.992 3.217-4.28 2.46-11.28 2.46-15.56 0zM35.399 129.601c-2.139-1.23-3.21-2.851-3.21-4.473 0-.638.167-1.273.494-1.886.202-.374.463-.738.787-1.087.497-.54 1.14-1.046 1.929-1.5 4.28-2.46 11.28-2.46 15.559 0 1.299.746 2.203 1.638 2.714 2.587.33.613.495 1.25.495 1.886 0 1.622-1.07 3.244-3.209 4.473-4.28 2.46-11.28 2.46-15.56 0zM14.997 203.612C4.203 197.406.925 188.45 5.166 180.572c.726-1.35 1.674-2.666 2.842-3.935 1.803-1.957 4.132-3.793 6.989-5.436 15.499-8.911 40.862-8.911 56.361 0 2.6 1.496 4.761 3.149 6.49 4.907 1.365 1.39 2.456 2.847 3.277 4.343l.067.122c4.238 7.876.962 16.833-9.834 23.04-15.499 8.91-40.862 8.91-56.361 0z",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M74.133 185.001a6.225 6.225 0 0 0-.148-.316l-14.8-29.72-32.072.12-14.609 29.354c-.006.01-.019.025-.025.037-.095.176-.18.351-.255.525-2.353 5.376 4.006 9.775 6.923 11.452 6.163 3.546 14.922 5.577 24.031 5.577 9.11 0 17.868-2.031 24.032-5.577 2.917-1.677 9.273-6.076 6.923-11.452z",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M59.185 154.966c.02.041.04.08.057.122.13.297.199.603.199.913 0 3.223-7.282 5.834-16.263 5.834-8.98 0-16.262-2.611-16.262-5.834 0-.31.068-.616.199-.913 1.22-2.79 7.948-4.924 16.063-4.924 7.998 0 14.647 2.072 16.007 4.802zM57.784 96.791c-.559 1.6-1.911 3.124-4.058 4.358-5.8 3.337-15.296 3.337-21.096 0-2.148-1.234-3.5-2.76-4.058-4.36",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M81.191 180.572l-27.023-56.3V107.17l3.616-10.378c-.04.114-.112.221-.16.333.048-.112.12-.221.16-.335.95-2.725-.403-5.67-4.058-7.77-5.8-3.337-15.296-3.337-21.096 0-3.655 2.1-5.008 5.045-4.058 7.77l3.618 10.38v17.103l-27.025 56.3c-4.238 7.878-.96 16.833 9.831 23.04 15.5 8.913 40.865 8.913 56.364 0 10.794-6.207 14.07-15.162 9.831-23.04z",
    stroke: "#33475C",
    strokeWidth: "5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M81.191 180.572l-27.023-56.3V107.17l3.616-10.38H28.572l3.618 10.38v17.103l-27.025 56.3c-4.238 7.878-.96 16.833 9.831 23.04 15.5 8.913 40.865 8.913 56.364 0 10.794-6.207 14.07-15.162 9.831-23.04",
    fill: "#BEE7EE",
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M32.63 101.15c-2.148-1.236-3.5-2.76-4.058-4.36-.95-2.727.402-5.67 4.058-7.77 5.8-3.337 15.295-3.337 21.096 0 3.657 2.1 5.008 5.043 4.058 7.77-.559 1.6-1.91 3.124-4.058 4.36-5.8 3.334-15.296 3.334-21.096 0",
    fill: "#E5F5F8",
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M35.399 111.006c-1.583-.909-2.58-2.035-2.992-3.217a3.777 3.777 0 0 1-.217-1.256c0-1.62 1.07-3.242 3.209-4.473 4.28-2.46 11.28-2.46 15.559 0 2.139 1.231 3.21 2.853 3.21 4.473 0 .421-.073.843-.218 1.256-.411 1.182-1.41 2.308-2.992 3.217-4.28 2.46-11.28 2.46-15.56 0zM35.399 129.601c-2.139-1.23-3.21-2.851-3.21-4.473 0-.638.167-1.273.494-1.886.202-.374.463-.738.787-1.087.497-.54 1.14-1.046 1.929-1.5 4.28-2.46 11.28-2.46 15.559 0 1.299.746 2.203 1.638 2.714 2.587.33.613.495 1.25.495 1.886 0 1.622-1.07 3.244-3.209 4.473-4.28 2.46-11.28 2.46-15.56 0zM14.997 203.612C4.203 197.406.925 188.45 5.166 180.572c.726-1.35 1.674-2.666 2.842-3.935 1.803-1.957 4.132-3.793 6.989-5.436 15.499-8.911 40.862-8.911 56.361 0 2.6 1.496 4.761 3.149 6.49 4.907 1.365 1.39 2.456 2.847 3.277 4.343l.067.122c4.238 7.876.962 16.833-9.834 23.04-15.499 8.91-40.862 8.91-56.361 0z",
    stroke: "#7CD1DF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M74.133 185.001a6.225 6.225 0 0 0-.148-.316l-14.8-29.72-32.072.12-14.609 29.354c-.006.01-.019.025-.025.037-.095.176-.18.351-.255.525-2.353 5.376 4.006 9.775 6.923 11.452 6.163 3.546 14.922 5.577 24.031 5.577 9.11 0 17.868-2.031 24.032-5.577 2.917-1.677 9.273-6.076 6.923-11.452",
    fill: "#FF7A53",
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M74.133 185.001a6.225 6.225 0 0 0-.148-.316l-14.8-29.72-32.072.12-14.609 29.354c-.006.01-.019.025-.025.037-.095.176-.18.351-.255.525-2.353 5.376 4.006 9.775 6.923 11.452 6.163 3.546 14.922 5.577 24.031 5.577 9.11 0 17.868-2.031 24.032-5.577 2.917-1.677 9.273-6.076 6.923-11.452z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M59.185 154.966c.02.041.04.08.057.122.13.297.199.603.199.913 0 3.223-7.282 5.834-16.263 5.834-8.98 0-16.262-2.611-16.262-5.834 0-.31.068-.616.199-.913 1.22-2.79 7.948-4.924 16.063-4.924 7.998 0 14.647 2.072 16.007 4.802",
    fill: "#FF9B7E",
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M59.185 154.966c.02.041.04.08.057.122.13.297.199.603.199.913 0 3.223-7.282 5.834-16.263 5.834-8.98 0-16.262-2.611-16.262-5.834 0-.31.068-.616.199-.913 1.22-2.79 7.948-4.924 16.063-4.924 7.998 0 14.647 2.072 16.007 4.802z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M57.784 96.791c-.559 1.6-1.911 3.124-4.058 4.358-5.8 3.337-15.296 3.337-21.096 0-2.148-1.234-3.5-2.76-4.058-4.36",
    stroke: "#00A4BF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), _react.default.createElement("path", {
    d: "M81.191 180.572l-27.023-56.3V107.17l3.616-10.378c-.04.114-.112.221-.16.333.048-.112.12-.221.16-.335.95-2.725-.403-5.67-4.058-7.77-5.8-3.337-15.296-3.337-21.096 0-3.655 2.1-5.008 5.045-4.058 7.77l3.618 10.38v17.103l-27.025 56.3c-4.238 7.878-.96 16.833 9.831 23.04 15.5 8.913 40.865 8.913 56.364 0 10.794-6.207 14.07-15.162 9.831-23.04z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

module.exports = exports.default;